import React, { useEffect, useState } from "react";
import { useAuth } from "@/auth";
import { useI18n } from "@/i18n";
import { Save } from "lucide-react";
import { toast } from "sonner";

export default function Prices() {
  const { api } = useAuth();
  const { t } = useI18n();
  const [margen, setMargen] = useState(15);
  const [guia, setGuia] = useState(25);

  useEffect(() => {
    api.get("/config").then(r => { setMargen(r.data.prices.margen); setGuia(r.data.prices.cargo_guia); });
  }, []);

  const save = async () => {
    await api.put("/config/prices", { margen: +margen, cargo_guia: +guia });
    toast.success(t("saved"));
  };

  return (
    <div className="max-w-md space-y-4" data-testid="prices-page">
      <h2 className="font-display text-lg font-semibold">{t("prices_margins")}</h2>
      <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-4">
        <div>
          <label className="block text-xs font-semibold text-slate-600 mb-1">{t("general_margin")}</label>
          <input data-testid="cfg-margen" type="number" value={margen} onChange={(e)=>setMargen(+e.target.value)} className="w-full px-3 py-2 border border-slate-300 rounded-lg" />
        </div>
        <div>
          <label className="block text-xs font-semibold text-slate-600 mb-1">{t("guide_charge")}</label>
          <input data-testid="cfg-guia" type="number" value={guia} onChange={(e)=>setGuia(+e.target.value)} className="w-full px-3 py-2 border border-slate-300 rounded-lg" />
        </div>
        <button data-testid="cfg-save" onClick={save} className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-4 py-2 rounded-lg flex items-center gap-2 transition-colors">
          <Save className="w-4 h-4" /> {t("save")}
        </button>
      </div>
    </div>
  );
}
